import { t } from 'commons/libs/i18n'
import * as yup from 'yup'

export const filterSchema = yup.object().shape({
  cnpj: yup.string().optional(),
  customerOrder: yup.string().optional(),
  endDate: yup
    .date()
    .typeError(() => t('common.validations.invalidDate'))
    .test(
      'is-less-or-equal',
      () => t('common.validations.endDateIsBeforeStartDate'),
      function (value) {
        const { startDate } = this.parent
        if (!startDate || !value) return true
        return new Date(value) > new Date(startDate)
      },
    ),
  legalName: yup.string().optional(),
  sapCode: yup.string().optional(),
  startDate: yup
    .date()
    .typeError(() => t('common.validations.invalidDate'))
    .test(
      'is-less-or-equal',
      () => t('common.validations.startDateIsAfterEndDate'),
      function (value) {
        const { endDate } = this.parent
        if (!endDate || !value) return true
        return new Date(value) <= new Date(endDate)
      },
    ),
  status: yup.array().of(yup.string()).optional(),
})
